import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import Sales from "../../../assests/devlopment/download (1).svg";
import Hr from "../../../assests/devlopment/download.svg";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import image1 from "../../mainSection/aboutPage/allAboutImages/images.png";
import image2 from "../../mainSection/aboutPage/allAboutImages/14.png";
import image3 from "../../mainSection/aboutPage/allAboutImages/Carousel3.jpeg";
import image4 from "../../mainSection/aboutPage/allAboutImages/Carousel6.png";
import bgimage from "../../../assests/image.png";
import bangalore from "../../../assests/location/bangalore.png";
import indore from "../../../assests/location/indore.png";
import delaware from "../../../assests/location/delaware.jpg";


const locationsData = [
  {
    region: "Asia",
    countries: [
      {
        name: "India",
        offices: [
          {
            city: "Bangalore",
            type: "Regional Office",
            address: "Innov8 Prestige Tech Park,ORR, Kadubeesanahalli, Bengaluru,Karnataka 56010",
            phone: "91-9343389975 (Sales) | 91-9685308585 (HR)",
             imageIndex: 0,
          },
          {
            city: "Indore",
            type: "Corporate Office",
            address:
              "India - 5, Samradhi Park,Indore, Madhya Pradesh 452016",
            phone: "91-9343389975 (Sales) | 91-9685308585 (HR)",
             imageIndex: 1,
          },
        
        ],
      },
    ],
  },
  {
    region: "North America",
    countries: [
      {
        name: "USA",
        offices: [
          {
            city: "Delaware",
            type: "Head Office",
            address: "TekIT Software, Delaware, USA – 19958",
            phone: "+1 XXX XXX XXXX",
              imageIndex: 2,
          },
        ],
      },
    ],
  },
  
];

const services = [
  {
    title: "Sales Enquiry",
    description: "For all sales inquiries, e-mail us at",
    image: Sales,
    email: "sales@tekitsolution.com",
    phone: "+91 - 9343389975",
  },
  {
    title: "Job Enquiry",
    description: "Submit your resume at",
    image: Hr,
    email: "hr@tekitsolution.com",
    phone: "+91 - 9685308585",
  },
];

const testimonials = [
  {
    id: 1,
    name: "ONGC",
    title: "",
    text: "We've been working together with TekIT Solution for more than 01 year now and it is has been a very positive experience for me and my company. TekIT Solution has been a trusted partner and always willing to help resolve the most complex of issues. The quality of the coding and in general work done has been very high. I would recommend them.",
    image: image1,
    rotation: "hover:rotate-0 rotate-[3deg]",
    hoverRotation: "rotate-[0deg]",
    role: "",
    rating: "https://www.immersiveinfotech.com/assets/images/rating.png",
  },
  {
    id: 2,
    name: "Apni Dukan",
    title: "",
    text: "TekIT Solution has not only met my expectations, they have exceeded them. I have provided most of the specs for the project which is application, which they have executed faithfully. I can highly recommend this company which has at all times in the development cycle of our project has met.",
    image: image2,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
    role: "",
    rating: "https://www.immersiveinfotech.com/assets/images/rating.png",
  },
  {
    id: 3,
    name: "Ganesh Agro",
    title: "",
    text: "TekIT Solution has done a great job taking our company's ideas and developing a website as per our niche specifications. The team is technicaly strong and creative. I'll not hesitate to recommend them.",
    image: image3,
    rotation: "hover:rotate-0 rotate-[3deg]",
    hoverRotation: "rotate-[0deg]",
    role: "",
    rating: "https://www.immersiveinfotech.com/assets/images/rating.png",
  },
  {
    id: 4,
    name: "Lalitpur Municipal Corporation",
    title: "",
    text: "We have been working with TekIT Solution for two years to develop a software application that supports the company’s daily activities. The TekIT Solution team is highly responsive and professional providing us with great problem solving on a daily basis. They are a tremendous extension of our team.",
    image: image4,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
    role: "",
    rating: "https://www.immersiveinfotech.com/assets/images/rating.png",
  },
  {
    id: 5,
    name: "AIIMS, New Delhi",
    title: "",
    text: "We trust TekIT. We are using the multiple Applications developed by TekIT as per our requirement. These Applications helped us in automating the traditional manual processes and we achieved a hike in overall efficiency.",
    image: image3,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
    rating: "https://www.immersiveinfotech.com/assets/images/rating.png",
  },
  {
    id: 6,
    name: "Alankaram",
    title: "",
    text: "TekIT Solution keeps doing what comes naturally to them which is building teams with their clients, partners and creating exceptional software development and support. Job well done. I have used them since 2018 for offshore development. Congratulations to all your teams.",
    image: image3,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
    rating: "https://www.immersiveinfotech.com/assets/images/rating.png",
  },
  {
    id: 7,
    name: "Armaf",
    title: "",
    text: "At Armaf, we are a couture collection of luxury french perfumes designer fragrances that exude class, style & elegance. TekIT provided us with an effective online sales platform and suggested us with strategic sales approach which accelerated our business. ",
    image: image3,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
    rating: "https://www.immersiveinfotech.com/assets/images/rating.png",
  },
  {
    id: 8,
    name: "Pinkz Fashion Boutique",
    title: "",
    text: "We were recommended to TekIT Solution by another company to look after our Digital Marketing. Since retaining them, they have managed our Digital Marketing Services",
    image: image3,
    rotation: "hover:rotate-0 -rotate-[2deg]",
    hoverRotation: "rotate-[0deg]",
    rating: "https://www.immersiveinfotech.com/assets/images/rating.png",
  },
];

const Countact_us = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    interest: "",
    budget: "",
    skype: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const location = useLocation();

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (scrollToId) {
      setTimeout(() => {
        const element = document.getElementById(scrollToId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 300); // Delay ensures DOM is ready
    }
  }, [location]);

  useEffect(() => {
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.skype.trim()) newErrors.skype = "Skype/WhatsApp is required";
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        const formDataObj = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
          formDataObj.append(key, value);
        });

        const response = await fetch(
          "https://www.tekitsolution.com/email_apis.php?action=contact_us",
          {
            method: "POST",
            body: formDataObj, // auto multipart/form-data
          }
        );

        const result = await response.json();
        alert("Form submitted successfully!");
      } catch (error) {
        console.error("Error:", error);
      }

      // setFormData({
      //     name: "",
      //     email: "",
      //     phone: "",
      //     interest: "",
      //     budget: "",
      //     skype: "",
      //     message: "",
      // });
      setErrors({});
    } else {
      setErrors(validationErrors);
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedRegion, setSelectedRegion] = useState(locationsData[0].region);

  const regionData = locationsData.find((region) => region.region === selectedRegion) || locationsData[0];
  const officeImages = [bangalore, indore,delaware];
 ;
  return (
    <div className="font-recoleta">
      <Helmet>
        <title>
          {" "}
          Contact Us | Get in Touch with Our Team for Support and Inquiries{" "}
        </title>
        <meta
          name="description"
          content="Have questions or need support? Contact us today! We're here to help with inquiries, feedback, and assistance. Reach out via phone, email, or our contact form."
        />
        <meta
          name="keywords"
          content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services"
        />
      </Helmet>
      <div className="relative w-full h-[560px] overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${bgimage})`,
          }}
        />

        {/* Content */}
        <div className="relative z-10 h-full flex items-end justify-start px-6 lg:px-40 2xl:-mt-6 lg:-mt-10">
          <div className="py-8">
            <h2 className="text-left text-white text-[32px] lg:text-[40px] 2xl:text-[50px]">
              Reach out.
            </h2>
            <p className="text-[26px] text-white lg:text-[32px] 2xl:text-[45px] mb-12">
              Let’s make it happen
            </p>
          </div>
        </div>
      </div>

      {/* <div className="relative 2xl:w-[94%] lg:w-[84%] w-full h-[500px] justify-self-center">
                <div
                    className="w-full h-full bg-cover bg-center bg-no-repeat"
                    style={{
                        backgroundImage: `linear-gradient(to right, rgba(254, 247, 237, 1), rgba(255, 255, 255, 0)), url('https://static.zohocdn.com/sites/stock-images/images/zpstock-image-1274.webp')`,
                    }}
                />
                <div className="absolute top-0 left-24 w-full h-full flex items-end justify-start">
                    <div className="container mx-auto py-8">
                        <h2 className="text-left text-black text-[50px]  2xl:text-[40px] lg:text-[32px] ">What’s on your mind ?</h2>
                        <p className='text-[45px] 2xl:text-[32px]  lg:text-[26px] mb-40'>We’ll connect you with the right expert.</p>
                    </div>

                </div>

            </div> */}
      <div
        className="absolute  lg:mt-[-110px] mt-[-66px] lg:block hidden"
        style={{ justifySelf: "anchor-center" }}
      >
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white border rounded-xl shadow-lg lg:p-8 p-4 text-center flex flex-col items-center hover:shadow-xl transition lg:w-[500px] w-[360px] z-1"
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-14 h-14 mb-4"
                />
                <h5 className="2xl:text-[26px]  lg:text-[20px] text-[28px] font-semibold mb-2 text-black">
                  <strong>{service.title}</strong>
                </h5>
                <p className="2xl:text-[20px]  lg:text-[16px] text-[26px] text-gray-600 mb-6 whitespace-pre-line">
                  Phone:<span>{service.phone}</span>
                </p>
                <p className="2xl:text-[20px]  lg:text-[16px] text-[25px] text-gray-600 mb-6 whitespace-pre-line">
                  {service.description}
                </p>

                <a
                  href={`https://mail.google.com/mail/?view=cm&fs=1&to=${service.email}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#09588D] text-white font-bold px-6 py-2 rounded-md hover:opacity-90 transition"
                >
                  GET IN TOUCH
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="absolute lg:mt-[-110px] mt-[-66px] w-full  justify-center items-center lg:hidden block">
        <div className="container mx-auto px-4 w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 justify-items-center">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white border rounded-xl shadow-lg lg:p-8 p-4 text-center flex flex-col items-center hover:shadow-xl transition lg:w-[500px] w-[360px] z-1"
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-14 h-14 mb-4"
                />
                <h5 className="2xl:text-[26px] lg:text-[20px] text-[28px] font-semibold mb-2 text-black">
                  <strong>{service.title}</strong>
                </h5>
                <p className="2xl:text-[20px] lg:text-[16px] text-[26px] text-gray-600 mb-6 whitespace-pre-line">
                  Phone: <span>{service.phone}</span>
                </p>
                <p className="2xl:text-[20px] lg:text-[16px] text-[25px] text-gray-600 mb-6 whitespace-pre-line">
                  {service.description}
                </p>

                <a
                  href={`https://mail.google.com/mail/?view=cm&fs=1&to=${service.email}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#09588D] text-white font-bold px-6 py-2 rounded-md hover:opacity-90 transition"
                >
                  GET IN TOUCH
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative w-full font-recoleta lg:mt-40 mt-[450px]">
        {/* Heading */}
        <div className=" lg:py-16 py-24 px-4">
          {/* <h2 className="text-3xl 2xl:text-[32px] lg:text-[26px] font-bold text-[#09588D]">
                        Ready to help, <br className="hidden md:block" />
                        all around the world
                    </h2> */}
        </div>


      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-8">
          Locations<span className="text-accent">.</span>
        </h1>

        <div className="flex gap-4 sm:gap-8 border-b border-border mb-12 overflow-x-auto">
          {locationsData.map((region) => (
            <button
              key={region.region}
              onClick={() => setSelectedRegion(region.region)}
              className={`pb-3 px-2 text-sm sm:text-base font-semibold whitespace-nowrap transition-all duration-300 ${
                selectedRegion === region.region
                  ? "border-b-2 border-accent text-foreground"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {region.region}
            </button>
          ))}
        </div>

        <div className="space-y-16">
          {regionData.countries.map((country) => (
            <div key={country.name}>
              <div className="bg-secondary px-6 py-4 rounded-lg mb-8">
                <h2 className="text-xl font-bold text-foreground">{country.name}</h2>
              </div>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {country.offices.map((office, index) => (
                  <div
                    key={index}
                    className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col min-h-[400px]"
                  >
                    <div
                      className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                      style={{
                        backgroundImage: `url(${officeImages[office.imageIndex % officeImages.length]})`,
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20" />
                    
                    <div className="relative z-10 flex flex-col justify-end h-full p-6 text-white">
                      <div className="space-y-3 mb-6">
                        <h3 className="text-2xl font-bold">{office.city}</h3>
                        <p className="text-accent font-semibold text-lg">{office.type}</p>

                        <div className="space-y-2 text-sm opacity-90">
                          <div className="flex items-start gap-2">
                            <span className="text-accent text-lg">📍</span>
                            <p className="leading-relaxed">{office.address}</p>
                          </div>
                      
                        </div>
                      </div>

                      <button  onClick={() => {
                        const section = document.getElementById("contact-form");
                        if (section) {
                          section.scrollIntoView({ behavior: "smooth" });
                        }
                      }} className="w-full text-white bg-[#09588D] hover:bg-primary/90 text-primary-foreground font-bold py-3 rounded-lg transition-all duration-300 transform hover:scale-105">
                        INQUIRY
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>


        <div className="relative w-full h-[600px]">
          <iframe
            title="Indore Location"
            src="https://www.google.com/maps?q=5,+Samriddhi+Park+Colony,+Pipliyahana+Rd,+near+Kothari+College,+Greater+Brajeshwari,+Indore,+Madhya+Pradesh+452016&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          {/* Office Info Card */}
          <div className="absolute -top-36 left-1/2 transform -translate-x-1/2 lg:right-10 lg:left-auto lg:translate-x-0 -translate-y-1/2 bg-white shadow-xl rounded-lg p-4 lg:p-10 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[400px] lg:mt-[144px] lg:hidden block z-50">
            <h3 className="text-lg lg:text-xl font-semibold text-white bg-[#09588D] inline-block px-3 py-1 rounded-t-md mb-3">
              Office Locations
            </h3>
            <div className="text-[#061f3e] text-xs sm:text-sm md:text-sm lg:text-sm leading-snug">
              <p className="font-bold mb-2 text-base sm:text-lg lg:text-lg leading-snug">
                INDIA - MP
              </p>
              <p className="text-sm lg:text-sm leading-snug">
                India - 5, Samradhi Park,
              </p>
              <p className="text-sm lg:text-sm leading-snug">
                Indore, Madhya Pradesh 452016
              </p>
              <p className="mt-3 text-sm lg:text-[12px] flex leading-snug">
                India{" "}
                <strong className="text-[#09588D] ml-1">
                  +91 - 9343389975
                </strong>{" "}
                (Sales)
              </p>
              <p className="text-sm lg:text-[12px] leading-snug">
                India{" "}
                <strong className="text-[#09588D] ml-1">
                  +91 - 9685308585
                </strong>{" "}
                (HR)
              </p>
            </div>
          </div>

          {/* <div className="absolute top-0 right-0 lg:right-10 transform -translate-y-1/2 bg-white shadow-xl rounded-lg p-6 lg:p-10 w-[40%] lg:w-[400px] lg:mt-[144px] mt-[-165px] hidden lg:block">
            <h3 className="text-2xl   lg:text-[20px] font-bold text-white bg-[#09588D] inline-block px-4 py-2 rounded-t-md mb-4">
              Office Locations
            </h3>
            <div className="text-[#061f3e] text-sm md:text-base leading-tight">
              <p className="font-bold mb-2 text-[18px] ">INDIA - MP</p>
              <p>India - 5, Samradhi Park, </p>
              <p>Indore, Madhya Pradesh 452016</p>
              <p className="font-bold mt-3 text-[18px]">BENGALURU</p>
              <p>Innov8 Prestige Tech Park,</p>
              <p>ORR, Kadubeesanahalli, Bengaluru,Karnataka 560103</p>

              <p className="mt-4 text-[22px] gap-4 flex leading-tight">
                India{" "}
                <strong className="text-[#09588D]"> +91-9343389975 </strong>{" "}
                (Sales)
              </p>
              <p className="text-[22px] flex gap-4 leading-tight">
                India <strong className="text-[#09588D]">+91-9685308585</strong>{" "}
                (HR)
              </p>
            </div>
          </div> */}
        </div>
      </div>

      <section
        id="contact-form"
        className="bg-[#09588D] text-white py-16 px-4 font-recoleta "
      >
        <div className=" mx-auto flex flex-col lg:flex-row gap-10">
          {/* Left Side: Form */}
          <div className="lg:w-1/2">
            <h2 className="text-[36px] 2xl:text-[32px] lg:text-[26px]  mb-6 font-recoleta">
              Let’s start executing innovative ideas and turn them into scalable
              results,
              <strong className="font-recoleta"> Talk to us now!</strong>
            </h2>

            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name *"
                    className={`w-full px-4 py-2 text-white lg:text-[18px] text-[42px] bg-transparent border-b-2 ${
                      errors.name ? "border-red-500" : "border-white/40"
                    } focus:outline-none focus:border-cyan-400 transition duration-200`}
                  />
                  {/* {errors.name && <p className="text-red-400 text-sm mt-1">{errors.name}</p>} */}
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email *"
                    className={`w-full px-4 py-2 text-white lg:text-[18px] text-[42px] bg-transparent border-b-2 ${
                      errors.email ? "border-red-500" : "border-white/40"
                    } focus:outline-none focus:border-cyan-400 transition duration-200`}
                  />
                </div>
                <div>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone No. *"
                    className={`w-full px-4 py-2 text-white lg:text-[18px] text-[42px] bg-transparent  border-b-2 ${
                      errors.phone ? " border-red-500" : "border-white/40"
                    } focus:outline-none focus:border-cyan-400 transition duration-200`}
                  />
                </div>
                <input
                  type="text"
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                  placeholder="Interest In"
                  className={`w-full px-4 py-2 text-white lg:text-[18px] text-[42px] bg-transparent border-b-2  border-white/40
                                         focus:outline-none focus:border-cyan-400 transition duration-200`}
                />
                <input
                  type="text"
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                  placeholder="Your Budget"
                  className={`w-full px-4 py-2 text-white lg:text-[18px] text-[42px] bg-transparent border-b-2 border-white/40 focus:outline-none focus:border-cyan-400 transition duration-200`}
                />
                <div>
                  <input
                    type="text"
                    name="skype"
                    value={formData.skype}
                    onChange={handleChange}
                    placeholder="Skype ID / WhatsApp No. *"
                    className={`w-full px-4 py-2 text-white lg:text-[18px] text-[42px] bg-transparent border-b-2 ${
                      errors.skype ? "border-red-500" : "border-white/40"
                    } focus:outline-none focus:border-cyan-400 transition duration-200`}
                  />
                </div>
              </div>

              <textarea
                rows="4"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                className={`w-full px-4 py-2 text-white bg-transparent lg:text-[18px] text-[42px] border-b-2 border-white/40 focus:outline-none focus:border-cyan-400 transition duration-200`}
              ></textarea>

              <div className="lg:text-right text-center">
                <button
                  type="submit"
                  className="bg-[#F86F4B] hover:bg-[#F86F4B]  lg:text-[18px] text-[42px] px-6 py-3 rounded shadow-md transition-all"
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>

          <div className="lg:w-1/2 font-recoleta px-40 lg:px-0">
            <h3 className="text-[48px] 2xl:text-[32px] lg:text-[26px] mb-6">
              Discover how TekIT Solution{" "}
              <strong className="block font-recoleta">
                {" "}
                brands towards success
              </strong>
            </h3>

            {/* Example static testimonial */}
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              loop={true}
              spaceBetween={30}
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                1024: { slidesPerView: 2 },
              }}
            >
              {testimonials.map((item, index) => {
                // Mark the one that will be in second visible position
                const secondVisibleIndex =
                  (activeIndex + 1) % testimonials.length;
                const isSecond = index === secondVisibleIndex;

                return (
                  <SwiperSlide key={index}>
                    <div
                      className={`p-6 px-10 rounded shadow-md h-[320px] ${
                        isSecond
                          ? "bg-gray-500 text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      {/* <img src={item.image} alt="quote" className="w-8 mb-4" /> */}
                      <p className="mb-4 text-[14px]">{item.text}</p>
                      <h6 className="font-semibold text-[16px]">{item.name}</h6>
                      <p className="text-sm text-black text-[16px]">
                        {item.role}
                      </p>
                      <img
                        src={item.rating}
                        alt="rating"
                        className="mt-2 w-28"
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Countact_us;
